import React from 'react'

import PendingIcon from '@mui/icons-material/Pending'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CancelIcon from '@mui/icons-material/Cancel'
import HelpIcon from '@mui/icons-material/Help'
import { Box, Typography } from '@mui/material'

const statuses = {
  Nil: {
    color: 'disabled',
    icon: HelpIcon,
  },
  Processing: {
    color: 'info',
    icon: PendingIcon,
  },
  Approved: {
    color: 'success',
    icon: CheckCircleIcon,
  },
  Rejected: {
    color: 'error',
    icon: CancelIcon,
  },
}

const Status = ({ status, ...rest }) => {
  const statusProps = statuses[status]
  if (!statusProps) {
    return (
      <Box {...rest}>
        <Typography variant='subtitle1'>{status || 'Unknown'}</Typography>
      </Box>
    )
  }
  const StatusIcon = statusProps.icon
  return (
    <Box display='flex' flexDirection='row' columnGap={1} alignItems='center' {...rest}>
      <StatusIcon color={statusProps.color} />
      <Typography variant='subtitle1' color={`${statusProps.color}.main`}>
        {status}
      </Typography>
    </Box>
  )
}

export default Status
